module.exports = __webpack_public_path__ + "static/sport/bgi-btn.0386782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-btn.png
// module id = OMql
// module chunks = 0